import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { INVALID_LINKEDIN_URL } = ERROR_TYPE;

/** The slim onboarding (V3) only collects the user's own LinkedIn profile. */
export const OnboardingSettingsV3Schema = z
	.object({
		linkedinUrl: z.string().optional(),
	})
	.superRefine(({ linkedinUrl }, ctx) => {
		if (linkedinUrl && !linkedinUrl.includes("linkedin.com/in/")) {
			ctx.addIssue({
				code: "custom",
				path: ["linkedinUrl"],
				message: INVALID_LINKEDIN_URL,
			});
		}
	});

export type OnboardingSettingsV3 = z.infer<typeof OnboardingSettingsV3Schema>;
